import { Component } from "react";
import WebFont from "webfontloader";
import PropTypes from "prop-types";

import FeedContainer from "../../components/FeedContainer";
import getLocalization from "../../components/localizationProvider";
import getSportData from "../../services/apiService";

import "../../styles/index.scss";

WebFont.load({
  google: {
    families: ["Bungee", "Lato", "Russo+One", "Roboto:400,900"],
  },
});

const DEFAULT_SPORTS = "nhl";
const DEFAULT_DELAY = 30;
const DEFAULT_LANG = "EN";

class AppContainer extends Component {
  constructor(props) {
    super(props);
    const { sports, lang, delay } = this.props.sc.config;
    this.state = {
      sports: sports ? sports : DEFAULT_SPORTS,
      delay: delay ? delay : DEFAULT_DELAY,
      lang: lang ? lang : DEFAULT_LANG,
      scores: [],
      isLoaded: false,
      isError: false,
    };
  }

  componentDidMount() {
    const refresh_time = 1000 * 60 * 60 * 6;
    this.intervalId = setInterval(
      () => this.getData(this.state.sports),
      refresh_time
    );
    // this.getTestData(this.state.sports);
    this.getData(this.state.sports);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  // getTestData(sport) {
  //   this.setState({
  //     scores: testData(sport),
  //     isLoaded: true
  //   });
  // }

  getData(sport) {
    return getSportData(sport)
      .then((result) => {
        this.setState({
          scores: result || [],
          isLoaded: true,
        });
      })
      .catch((err) => {
        console.warn("Fetch data error", err);
        setTimeout(() => {
          this.props.sc.emitFinished({ err });
          clearInterval(this.intervalId);
        }, 10000);

        this.setState({
          isError: true,
        });
      });
  }

  render() {
    const {
      isLoaded,
      lang,
      delay,
      scores,
      sports,
      hva,
      hha,
      htp,
      ava,
      aha,
      atp,
      sva,
      stp,
    } = this.state;

    const localization = getLocalization(lang);

    if (window.innerWidth / window.innerHeight > 5) {
      return (
        <div className="warning-message">
          <span>{localization.zoneWarning}</span>
        </div>
      );
    } else if (!isLoaded) {
      return <div className="warning-message">Loading....</div>;
    } else if (isLoaded && scores && !scores.length) {
      return (
        <div>
          <div className="warning-message">
            <span>
              <h1>End Of Season</h1>
            </span>
          </div>
        </div>
      );
    } else {
      return (
        <FeedContainer
          positionConfig={{
            hva,
            hha,
            htp,
            ava,
            aha,
            atp,
            sva,
            stp,
          }}
          sportName={sports}
          fontFamily="RussoOne"
          textColor="light"
          duration={Number(delay)}
          items={scores}
          lang={lang}
        />
      );
    }
  }
}

AppContainer.propTypes = {
  sc: PropTypes.object,
};

export default AppContainer;
